<driver-panel-layout>

    <ng-content></ng-content>

</driver-panel-layout>